import { Pipe, PipeTransform } from '@angular/core';

import { ApiFragment } from '../entities/api-fragment.entity';

@Pipe({
    standalone: false,
    name: 'getShortRecordId',
    pure: true
})
export class GetShortRecordIdPipe implements PipeTransform {
    transform(record: ApiFragment | string): string {
        if (record instanceof ApiFragment) {
            return this.transform(record.getRecordId());
        } else {
            return record.slice(0, 10);
        }
    }
}
